'use strict';

SC.rider_tips = (function () {
  /**
     * Duration for animations.
     */
  var ANIMATIONS_DURATION = 350;

  /**
     * Limit for more topic items.
     */
  var MORE_TOPIC_ITEMS_LIMIT = 4;

  /**
     * API for external use.
     */
  var api = {};

  /**
     * Rider Tips internal data.
     */
  var riderTipsData = window.riderTipsData || [];

  /**
     * Window object of the browser.
     */
  var $window = $(window);

  /**
     * Content body of the DOM.
     */
  var $body = $('body');

  /**
     * Template for a more topic item.
     */
  var moreTopicItemTemplate = $body.find('#more-topic-item--template').html();

  /**
     * Content element of the DOM.
     */
  var $riderTips = $body.find('.rider-tips');

  /**
     * Elements of the DOM.
     */
  var $categoryToggle;
  var $categoryToggleLabel;
  var $subMenuContainer;
  var $previousTopic;
  var $nextTopic;
  var $heroImageContainer;
  var $heroImage;
  var $heroVideoContainer;
  var $heroVideo;
  var $topicTitle;
  var $topicDescription;
  var $moreTopicsContainer;
  var $moreTopicsTitle;
  var $moreTopicsList;

  /**
     * Rider Tips topics data.
     */
  var riderTipsTopics;

  /**
   * Initializes the back end logic bindings.
   *
   * @returns {void}
   */
  var init = function () {
    initRiderTipsTopics();
    initUi();
    initListeners();
    updateUi();
  };

  /**
   * Initializes the Rider Tips topics data.
   * @returns {void}
   */
  var initRiderTipsTopics = function () {
    riderTipsTopics = [];
    var topicIndex = 0;
    riderTipsData.categories.forEach(function (category) {
      category.topics.forEach(function (topic, categoryIndex) {
        topic.category = category.name;
        topic.categoryIndex = categoryIndex;
        topic.index = topicIndex++;
        riderTipsTopics.push(topic);
      });
    });
  };

  /**
   * Initializes the user interface element bindings.
   * @returns {void}
   */
  var initUi = function () {
    $categoryToggle = $riderTips.find('.category-toggle');
    $categoryToggleLabel = $categoryToggle.find('.top-category-label');
    $subMenuContainer = $riderTips.find('.sub-menu-container');
    $previousTopic = $riderTips.find('.previous-topic');
    $nextTopic = $riderTips.find('.next-topic');
    $heroImageContainer = $riderTips.find('.hero-image-container');
    $heroImage = $heroImageContainer.find('.hero-image');
    $heroVideoContainer = $riderTips.find('.hero-video-container');
    $heroVideo = $heroVideoContainer.find('.hero-video');
    $topicTitle = $riderTips.find('.topic-title');
    $topicDescription = $riderTips.find('.topic-description');
    $moreTopicsContainer = $riderTips.find('.more-topics-container');
    $moreTopicsTitle = $moreTopicsContainer.find('.more-topics-title');
    $moreTopicsList = $moreTopicsContainer.find('.more-topics-list');
  };

  /**
   * Initializes the event listener element bindings.
   * @returns {void}
   */
  var initListeners = function () {
    // Bind window listeners.
    $window
      .on('hashchange', updateUiData)
      .on('resize', updateUiAssets)
    ;

    // Bind page listeners.
    $riderTips
      .on('click', '.js-toggle-categories-sub-menu', toggleCategoriesSubMenu)
      .on('click', '.js-toggle-category-sub-menu-list', toggleCategorySubMenuList)
      .on('click', '.js-collapse-sub-menu-container', collapseSubMenuContainer)
    ;

    // Trigger window listeners.
    $window
      .trigger('resize')
    ;
  };

  /**
   * Updates the user interface element bindings.
   * @returns {void}
   */
  var updateUi = function () {
    // Validate current topic.
    var locationHash = window.location.hash;
    if (!isValidTopic(locationHash)) {
      window.location.hash = getTopicByIndex(0).anchor;
    } else {
      updateUiData();
    }
  };

  /**
   * Updates the user interface element data.
   * @returns {void}
   */
  var updateUiData = function () {
    // Validate current topic.
    var locationHash = window.location.hash;
    if (!isValidTopic(locationHash)) {
      window.location.hash = getTopicByIndex(0).anchor;
      return;
    }

    // Update page title.
    var currentTopic = getTopicByAnchor(locationHash);
    document.title = 'About: ' + currentTopic.title;

    // Update page content.
    updateUiMenu(currentTopic);
    updateUiNavigation(currentTopic);
    updateUiContent(currentTopic);

    // Scroll page to top.
    $('html, body').scrollTop(0);

    // Track current topic `pageview`.
    var page = window.location.pathname + locationHash;
    ga('set', 'page', page);
    ga('send', {
      hitType: 'pageview',
      title: window.document.title,
      location: window.location.origin,
      page: page
    });
  };

  /**
   * Updates the user interface element assets.
   * @returns {void}
   */
  var updateUiAssets = function () {
    // Prevent sub menu container collapse, only on desktop.
    if (!SC.utils.is_mobile_device()) {
      $subMenuContainer.slideDown();
    }

    // Update videos height.
    $heroVideo.css({ 'max-height': $heroImage.css('height') });
  };

  /**
   * Updates the user interface element menu.
   *
   * @param {Object} currentTopic Topic currently selected.
   * @returns {void}
   */
  var updateUiMenu = function (currentTopic) {
    // Update category labels.
    $categoryToggleLabel.text(currentTopic.category);

    // Reset category toggle, only if visible.
    if ($categoryToggle.is(':visible')) {
      $categoryToggle.removeClass('expanded');
    }

    // Reset category/topic labels.
    $subMenuContainer.find('.top-category-label, .sub-category-label').removeClass('active');

    // Highlight current topic.
    var $currentSubCategoryLabel = $subMenuContainer.find('[href="' + window.location.hash + '"]');
    $currentSubCategoryLabel.addClass('active');

    // Highlight current category.
    var $currentTopCategoryLabel = $currentSubCategoryLabel.closest('.top-menu-item').find('.top-category-label');
    $currentTopCategoryLabel.addClass('active');

    // Collapse sub menus, except current one.
    $subMenuContainer.find('.sub-menu-list').removeClass('expanded');
    $currentTopCategoryLabel.siblings('.sub-menu-list').addClass('expanded').slideDown();
    $subMenuContainer.find('.sub-menu-list:not(.expanded)').slideUp();
  };

  /**
   * Updates the user interface element navigation.
   *
   * @param {Object} currentTopic Topic currently selected.
   * @returns {void}
   */
  var updateUiNavigation = function (currentTopic) {
    // Set topic index.
    var currentTopicIndex = currentTopic.index;

    // Get adjacent topics.
    var previousTopic = getTopicByIndex(currentTopicIndex - 1);
    var nextTopic = getTopicByIndex(currentTopicIndex + 1);

    // Set state variables.
    var isFirstTopic = (currentTopicIndex === 0);
    var isLastTopic = (currentTopicIndex === riderTipsTopics.length - 1);

    // Set topic labels.
    var previousTopicLabel = (!isFirstTopic) ? previousTopic.title : 'Back to Last Topic';
    var nextTopicLabel = (!isLastTopic) ? nextTopic.title : 'Jump to First Topic';

    // Update topics information.
    $previousTopic.attr('href', previousTopic.anchor).text(previousTopicLabel);
    $nextTopic.attr('href', nextTopic.anchor).text(nextTopicLabel);

    // Update topics state.
    $previousTopic.toggleClass('active', !isFirstTopic).toggle(!isFirstTopic);
    $nextTopic.toggleClass('active', !isLastTopic);
  };

  /**
   * Updates the user interface element content.
   *
   * @param {Object} currentTopic Topic currently selected.
   * @returns {void}
   */
  var updateUiContent = function (currentTopic) {
    // Set state variables.
    var isFirstCategoryTopic = (currentTopic.categoryIndex === 0);
    var isFirstTopic = (currentTopic.index === 0);

    // Update topic assets.
    if (currentTopic.assetType === 'image') {
      $heroImage.attr('src', currentTopic.imageUrl);
      $heroImage.removeClass('hidden');
      $heroVideoContainer.hide();
    } else {
      $heroVideo.attr('src', currentTopic.videoUrl);
      $heroImage.addClass('hidden');
      $heroVideoContainer.show();
    }

    // Update topic information.
    $topicTitle.text((!isFirstCategoryTopic) ? currentTopic.title : '');
    $topicDescription.html(currentTopic.description);

    // Update more topics title.
    $moreTopicsTitle.text((!isFirstTopic) ? 'More topics in ' + currentTopic.category + ':' : 'More categories:');

    // Update more topic items.
    var categoryTopics = getTopicsByCategory(currentTopic.category);
    var limitedTopics = (!isFirstTopic)
      ? getLimitedTopics(currentTopic, categoryTopics, MORE_TOPIC_ITEMS_LIMIT)
      : getCategoryTopics(currentTopic)
        ;
    var moreTopicItemsHtml = '';
    limitedTopics.forEach(function (topic) {
      // Clean more topic item.
      var $moreTopicDescription = $('<span />').html(topic.description);
      $moreTopicDescription.find('a').contents().unwrap();

      // Build more topic item.
      var moreTopicItemHtml = moreTopicItemTemplate
        .replace('{{ topic.assetType }}', topic.assetType)
        .replace('{{ topic.anchor }}', topic.anchor)
        .replace('{{ topic.thumbnailUrl }}', topic.thumbnailUrl)
        .replace('{{ topic.title }}', topic.title)
        .replace('{{ topic.description }}', $moreTopicDescription.html());

      // Append more topic item.
      moreTopicItemsHtml += moreTopicItemHtml;
    });
    $moreTopicsList.html(moreTopicItemsHtml);

    // Update more topic container.
    if (limitedTopics.length > 1) {
      $moreTopicsContainer.show();
    } else {
      $moreTopicsContainer.hide();
    }
  };

  /**
   * Toggles the categories sub menu.
   * @returns {void}
   */
  var toggleCategoriesSubMenu = function () {
    $categoryToggle.toggleClass('expanded');
    $subMenuContainer.slideToggle(ANIMATIONS_DURATION);
  };

  /**
   * Toggles the category sub menu list.
   * @returns {void}
   */
  var toggleCategorySubMenuList = function () {
    $(this).siblings('.sub-menu-list').slideToggle(ANIMATIONS_DURATION);
  };

  /**
   * Collapses the sub menu container, only on mobile.
   * @returns {void}
   */
  var collapseSubMenuContainer = function () {
    if (SC.utils.is_mobile_device()) {
      $subMenuContainer.slideUp();
    }
  };

  /**
   * Determines whether or not the topic is valid.
   *
   * @param {string} anchor The anchor.
   * @return {boolean} Whether or not the topic is valid.
   */
  var isValidTopic = function (anchor) {
    if (!anchor) {
      return false;
    }
    var topic = riderTipsTopics.find(function (topic) { // eslint-disable-line no-shadow
      return (topic.anchor === anchor);
    });
    return (topic !== undefined);
  };

  /**
   * Gets the topic, filtered by index.
   *
   * @param {number} _index The index.
   * @return {Object} The topic, filtered by index.
   */
  var getTopicByIndex = function (_index) {
    var index = _index;

    if (index === -1) {
      index = riderTipsTopics.length - 1;
    } else if (index === riderTipsTopics.length) {
      index = 0;
    }

    return riderTipsTopics[index];
  };

  /**
   * Gets the topic, filtered by anchor.
   *
   * @param {string} anchor The anchor.
   * @return {Object} The topic, filtered by anchor.
   */
  var getTopicByAnchor = function (anchor) {
    return riderTipsTopics.find(function (topic) {
      return (topic.anchor === anchor);
    });
  };

  /**
   * Gets the topics, filtered by category.
   *
   * @param {Object} category The category.
   * @return {Array<Object>} The topics, filtered by category.
   */
  var getTopicsByCategory = function (category) {
    return riderTipsTopics.filter(function (topic) {
      return (topic.category === category);
    });
  };

  /**
   * Gets the topics, per category.
   *
   * @param {Object} currentTopic Topic currently selected.
   * @return {Array<Object>} The topics, per category.
   */
  var getCategoryTopics = function (currentTopic) {
    // Set next topics.
    var categoryTopics = riderTipsData.categories.reduce(function (currentTopics, category) {
      currentTopics.push(category.topics[0]);
      return currentTopics;
    }, []);

    // Limit category topics.
    categoryTopics = getLimitedTopics(currentTopic, categoryTopics, 0);

    // Return category topics.
    return categoryTopics;
  };

  /**
   * Gets the topics, limited by amount.
   *
   * @param {Object}        currentTopic Topic currently selected.
   * @param {Array<Object>} topics       The topics.
   * @param {number}        limit        The limit.
   * @return {Array<Object>} The topics, limited by amount.
   */
  var getLimitedTopics = function (currentTopic, topics, limit) {
    // Set next topics.
    var limitedTopics = topics.reduce(function (currentTopics, topic) {
      if (topic.index > currentTopic.index) {
        currentTopics.push(topic);
      }
      return currentTopics;
    }, []);

    // Set previous topics, only if needed.
    if (limit > 0) {
      limitedTopics = (limitedTopics.length > limit)
        ? limitedTopics.slice(0, limit)
        : topics.slice(1, limit - limitedTopics.length + 1).concat(limitedTopics)
      ;
    }

    // Filter current topic.
    limitedTopics = limitedTopics.filter(function (topic) {
      return (topic.index !== currentTopic.index);
    });

    // Filter duplicates topics.
    limitedTopics = limitedTopics.filter(function (topic, index, array) {
      return (array.indexOf(topic) === index);
    });

    // Return limited topics.
    return limitedTopics;
  };

  init();
  return api;
})();
